<template>
  <v-sheet class="pa-4 h-100">
    <v-sheet outlined class="rounded overflow-hidden h-100 d-flex flex-column">
      <div
        class="pa-2 pb-0 d-flex align-center justify-space-between"
        style="gap: 8px"
        :class="{
          'flex-wrap': $vuetify.breakpoint.xs,
        }">
        <h3>Manage Contracts</h3>
        <v-btn v-has="permissions.Contracts.Create" @click="update()" small color="primary"
          ><v-icon left>mdi-plus</v-icon> Add Contract</v-btn
        >

        <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>
        <v-sheet :width="$vuetify.breakpoint.xs ? '100%' : 250">
          <v-text-field
            hide-details
            outlined
            v-model="options.search"
            dense
            class="search-bar"
            placeholder="Search in contracts..."
            clearable
            prepend-inner-icon="mdi-magnify"></v-text-field>
        </v-sheet>
      </div>

      <v-data-table
        class="elevation-0 pa-2 rounded-0 d-flex flex-column table-sticky custom-table"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-chevron-double-left',
          lastIcon: 'mdi-chevron-double-right',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
          itemsPerPageText: 'Row/Page',
          itemsPerPageOptions: [15, 30, 50, 100, 200, 300, 400, 500, -1],
        }"
        :headers="contractHeaders"
        :items="entries"
        :options.sync="options"
        :loading="loading"
        @click:row="onRowClick"
        :server-items-length="total">
        <template v-slot:[`item.agreementDate`]="{ item }">
          {{ $formatDate(item.agreementDate) }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-menu dense offset-x right>
            <template v-slot:activator="{ attrs, on }">
              <v-btn icon elevation="0" v-bind="attrs" v-on="on">
                <v-icon size="16px">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list class="more-options-menu" dense>
              <v-list-item v-has="permissions.Contracts.Update" @click="update(item.id)" dense>
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small>mdi-pencil-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Update</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-has="permissions.Contracts.Delete" @click="del(item.id)" dense>
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small color="error">mdi-delete-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title> Delete</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:no-data>
          <div class="text-center d-flex flex-column">
            <img width="300" src="/img/notFound.svg" class="py-5 my-8" style="opacity: 0.54" />
            <p class="font-weight-medium">No Data Available!</p>
          </div>
        </template>

        <template v-slot:loading>
          <div class="text-center d-flex flex-column">
            <img width="300" src="/img/loading.svg" class="py-5 my-8" style="opacity: 0.54" />
            <p class="font-weight-medium">Loading Contracts...</p>
          </div>
        </template>
      </v-data-table>
      <EditContract ref="editContract"></EditContract>
    </v-sheet>
  </v-sheet>
</template>

<script>
  import contractHeaders from '@Contract/config/contract.headers';
  import { mapGetters } from 'vuex';
  import EditContract from '@Contract/components/EditContract.vue';
  import permissions from '@Share/config/permissions';
  import { $formatDate } from '@Utils';
import { $has } from '@/utils';

  export default {
    name: 'contract-list',
    data() {
      return {
        contractHeaders,
        activeContracts: true,
        permissions,
        timerId: null,
      };
    },
    computed: {
      ...mapGetters('CONTRACT', {
        loading: 'GET_LOADING',
        entries: 'GET_ENTRIES',
        total: 'GET_TOTAL',
      }),
      ...mapGetters('ACCOUNT', {
        company: 'GET_COMPANY',
      }),
      options: {
        get() {
          return this.$store.getters['CONTRACT/GET_OPTIONS'];
        },
        set(val) {
          this.$store.commit('CONTRACT/SET_OPTIONS', val);
        },
      },
    },
    methods: {
      $formatDate,
      getDataDebounced() {
        if (this.timerId == null) {
          this.timerId = -1;
          this.$store.dispatch('CONTRACT/GET');
          return;
        }
        // cancel pending call
        clearTimeout(this.timerId);

        // delay new call 400ms
        this.timerId = setTimeout(() => {
          this.$store.dispatch('CONTRACT/GET');
        }, 400);
      },
      update(contractItemId = null) {
        this.$refs.editContract.open(contractItemId, true);
      },
      del(id) {
        this.$dialog.error({
          text: 'Are You Sure You Want to Delete This Contract?',
          title: 'Delete Role',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                return this.$store.dispatch('CONTRACT/DELETE', id);
              },
            },
          },
        });
      },
      onRowClick(item) {
        if (!$has(permissions.TaskBoardProjects.View)) return;
        this.$router.push({
          name: 'projects',
          params: {
            id: this.$route.params.id,
            contractId: item.id,
          },
        });
      },
    },
    watch: {
      options: {
        deep: true,
        handler() {
          this.getDataDebounced();
        },
      },
    },
    components: {
      EditContract,
    },
  };
</script>
